<template>
  <div class="flex items-center justify-center w-screen h-screen splash" style="background-image: linear-gradient(60deg, rgb(8, 24, 43) 0%, rgb(44, 43, 43) 100%);">
    <div class="space-y-8">
      <h2 class="text-white slide__title-small font-display" style="opacity: 1;">Pose XR</h2>

      <!-- Progress Bar -->
      <div class="relative pt-1 px-4" v-if="progress > 0">
        <AppProgressBar v-bind:progress="progress" />
      </div>
      <!-- Spinner -->
      <div class="text-center" v-else-if="!playerReadyForSetup">
        <i class="text-white fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <!-- Button -->
      <div class="mt-2" v-if="playerReadyForSetup">
        <button @click.prevent="$emit('setup')" type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
          Launch the experience
        </button>
      </div>

    <p class="text-lg text-center text-white p-4" v-if="playerHasTimedOut || !playerReadyForSetup">
        <template v-if="playerHasTimedOut">Player timed out due to inactivity. Start a new session.</template>
        <template v-else>Please wait a moment while the experience loads...</template>
    </p>
    </div>

    <!--    <div
              v-if="!playerLaunched && !forceShowUI"
              class="absolute top-0 left-0 z-50 w-full h-full p-2 bg-yellow-500">
              <div class="" v-if="playerReadyForSetup">
                <div class="">
                  <button
                    @click.prevent="setupFurioos"
                    type="button"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <template v-if="playerHasServerAvailabilityError">Retry Launch</template>
                    <template v-else>Launch</template>
                  </button>

                  <div v-if="playerHasTimedOut">
                    <p class="text-sm">
                      Player timed out due to inactivity. Start a new session.
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <AppProgressBar v-bind:progress="playerLoadingProgress" />
                {{ playerStateMessage }}
              </div>

              <div
                class="p-2 mb-2 bg-red-500"
                v-if="playerHasServerAvailabilityError">
                <p class="mb-1 text-lg">Server not available.</p>
                <p>{{ playerServerAvailabilityResponse }}</p>
              </div>

              <div
                class="p-2 mt-2 text-gray-700 bg-white bg-opacity-10"
                v-if="showDebug">
                <h3 class="font-bold">Debug</h3>
                <ul>
                  <li>{{ playerServerAvailabilityResponse }}</li>
                  <li>
                    Player <span v-if="player !== null">Attached</span><span v-else>Not Ready</span>
                  </li>
                  <li>
                    Message:
                    {{ playerStateMessage }}
                  </li>
                  <li>State: {{ playerState }}</li>
                  <li>Progress: {{ playerLoadingProgress }}</li>
                  <li>User: {{ playerUserState }}</li>
                </ul>
              </div>
            </div>
-->
  </div>
</template>
<script>
const AppProgressBar = () => import("@/components/app/AppProgressBar");
export default {

    components: {
        AppProgressBar
    },

    props: {
        progress: {
            type: Number,
            default: 0
        },
        playerReadyForSetup: {
            type: Boolean,
            default: false
        },
        playerHasTimedOut: {
            type: Boolean,
            default: false
        }
    }
}
</script>
